var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"callout-block",class:['variant-' + _vm.variant, { selected: _vm.selected }]},[(_vm.block.title)?_c('div',{staticClass:"font-weight-medium mb-1"},[_vm._v(" "+_vm._s(_vm.block.title)+" ")]):_vm._e(),_c('TextBlock',{attrs:{"block":_vm.textProxy,"variables":_vm.variables},on:{"update":_vm.onInner}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }